import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Unauthorized from "./AdminSide/Unauthorized";
import {
  getAdminRole,
  isAdminAuthenticated,
  isAdminLoginPath,
  isPathAllowedForAdminRole,
  getDefaultAdminPath,
} from "../utils/adminAuth";

const AdminRoute = () => {
  const location = useLocation();
  const isAuthenticated = isAdminAuthenticated();
  const role = getAdminRole();

  if (isAdminLoginPath(location.pathname)) {
    if (isAuthenticated) {
      return <Navigate to={getDefaultAdminPath(role)} replace />;
    }
    return <Outlet />;
  }

  if (role === "ticket_checkin") {
    if (!isAuthenticated) {
      return <Navigate to="/AdminLogin" replace state={{ from: location }} />;
    }

    if (!isPathAllowedForAdminRole(location.pathname, location.search, role)) {
      return <Navigate to="/AdminCheckIn" replace />;
    }

    return <Outlet />;
  }

  if (isAuthenticated && !isPathAllowedForAdminRole(location.pathname, location.search, role)) {
    return <Unauthorized />;
  }

  return <Outlet />;
};

export default AdminRoute;
